import React from 'react'

import { SearchContext } from './search-context'

export const SearchContextProvider = ({
  children,
  value,
}: {
  children: React.ReactNode
  value: { query: string; results: unknown[] }
}) => <SearchContext.Provider value={value}>{children}</SearchContext.Provider>
